<router-outlet></router-outlet>
<notifier-container></notifier-container>
<ngx-loading [show]="loadingService.isLoading$ | async"
    [config]="{ backdropBorderRadius: '14px',fullScreenBackdrop:true }"></ngx-loading>